export default __webpack_public_path__ + "static/media/check-12x9.a25818e8.svg";